import React__default from 'react';
import { ThemeProvider as ThemeProvider$1 } from 'styled-components';
import { defaultToolkitTheme } from './defaultToolkitTheme.js';

var ThemeProvider = function (_a) {
  var theme = _a.theme,
    children = _a.children;
  return React__default.createElement(ThemeProvider$1, {
    theme: theme
  }, children);
};
ThemeProvider.defaultProps = {
  theme: defaultToolkitTheme
};

export { ThemeProvider };
//# sourceMappingURL=ThemeProvider.js.map
